export default __webpack_public_path__ + "static/media/powerpointicon.a2c2ff40.svg";